import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { currency } from "../config"
import { removePriceDecimal } from "../helpers"

import Product from "./Product"
import MobileQuickAdd from "./MobileQuickAdd"

export default function Products({ setSizeGuideOpen }) {
    const { products } = useAppStateSelector(state => ({ products: state.response.products }));
    const [ mobileQAOpen, setMobileQAOpen ] = useState(false);
    const [ mobileQaProduct, setMobileQaProduct ] = useState(null);

    useEffect(() => {
        if(currency !== 'USD' && typeof window.Nosto?.migrateToShopifyMarket === "function"){
            const unprocessedProducts = document.querySelectorAll('#ns-product-grid .ns-markets:not(.ns-markets-updated)');
            
            if (unprocessedProducts.length === 0) return;

            window.Nosto?.migrateToShopifyMarket({
                productSectionElement: '#ns-product-grid .ns-markets:not(.ns-markets-updated)',
                productUrlElement: '.ns-product-link',
                productHandleAttribute: 'data-handle',
                priceElement: '.ns-product-price',
                listPriceElement: '.ns-product-list-price',
            }).finally(() => {
                document.querySelectorAll('#ns-product-grid .ns-markets:not(.ns-markets-updated)').forEach(el => {
                    el.querySelectorAll('.ns-product-price, .ns-product-list-price').forEach(priceEl => {
                        priceEl.textContent = removePriceDecimal(priceEl.textContent);
                    })
                    el.classList.add('ns-markets-updated')
                })
            })
        }
    }, [ products?.hits, currency ]);

    const openMobileQuickAdd = (product) => {
        setMobileQaProduct(product);
        setMobileQAOpen(true);
    }

    return (
        <>
            <MobileQuickAdd 
                open={mobileQAOpen} 
                setOpen={setMobileQAOpen}
                product={mobileQaProduct} 
                setSizeGuideOpen={setSizeGuideOpen}
            />
            <ol 
                id="ns-product-grid" 
                class="ns-grid"
            >
                {products.hits.map((hit, index) => (
                    <Product 
                        key={hit.productId || index} 
                        product={hit}
                        setSizeGuideOpen={setSizeGuideOpen} 
                        openMobileQuickAdd={openMobileQuickAdd}
                    />
                ))}
            </ol>
        </>
    )
}
